<template>
  <div class="banners">
    <div v-for="(banner, index) in computedBanners.filter(Boolean)" :key="index" class="banner">
      <div
        class="icon-wrapper"
        :style="{ background: banner.backgroundColor, borderRadius: '7px' }"
      >
        <IconProductAvailability v-if="banner.static" :size="40" class="icon-check" />
        <img v-else :class="{ icon: true }" :src="banner.icon" />
      </div>
      <div class="label" data-test-id="text__info-motivation" v-html="banner.label" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { IBanner } from '../../models/banner';
import { useProductPage } from '../../business/use-product-page';
import { IconProductAvailability } from '@/features/ui-kit/icons';

// Get product page state
const { state } = useProductPage();

interface Props {
  banners: IBanner[] | null;
}

const props = defineProps<Props>();

const currentSku = computed(() => {
  return state.currentSku || null;
});

const computedBanners = computed((): IBanner[] => {
  if (!currentSku.value) {
    return props.banners || [];
  }

  const availableAmount = currentSku.value.availableAmount;
  let label;

  if (availableAmount > 5) {
    label = `Доступно ${availableAmount} шт.`;
  } else if (availableAmount > 1) {
    label = `Осталось ${availableAmount} шт.`;
  } else if (availableAmount === 1) {
    label = 'Последний остался!';
  } else {
    label = 'Нет в наличии';
  }

  const result: IBanner[] = [
    {
      label: label,
      icon: '', // Icon is rendered as component, not img
      backgroundColor: `#D7F5DD`,
      static: true,
    },
  ];

  if (props.banners) {
    result.push(...props.banners);
  }

  return result;
});
</script>

<style lang="stylus" scoped>
.banners
  .banner
    display flex
    column-gap 12px
    align-items center
    &:not(:first-child)
      margin-top 16px
    .icon-wrapper
      width 40px
      height 40px
      border-radius 8px
      display flex
      align-items center
      justify-content center
      .icon
        height 40px
        width 40px
      .icon-check
        // Padding 6px добавлен специально для иконки "в наличии" чтобы соответствовать legacy дизайну
        padding 6px
        color #000000
        display flex
        align-items center
        justify-content center
    .label
      font-weight 400
      font-size 14px
      line-height 18px
      letter-spacing -0.01em
      color Gray(DK40)
</style>
